import { createAction, props } from '@ngrx/store';
import { DashboardKpiTimeRange } from '../../enums/dashboard-kpi-time-range.enum';
import { DashboardKpis } from '../../interfaces/dashboard-kpis.interface';

export const loadDashboardKpis = createAction(
  '[DashboardKpis/API] Load Dashboard KPIs',
  props<{ timeRange: DashboardKpiTimeRange }>()
);

export const loadDashboardKpisSuccess = createAction(
  '[DashboardKpis/API] Load Dashboard KPIs Success',
  props<{ dashboardKpis: DashboardKpis }>()
);

export const loadDashboardKpisFailure = createAction(
  '[DashboardKpis/API] Load Dashboard KPIs Failure',
  props<{ error: unknown }>()
);

export const clearDashboardKpis = createAction('[DashboardKpis/API] Clear Dashboard KPIs');
